import Table from '@/components/Table/Table';

export default Table;
